/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type {
    BoundaryResponse,
    CreateBoundaryRequest,
    GetBoundariesParams,
    PagedResponseBoundaryResponse,
    UpdateBoundaryRequest
} from '../models';

export type getBoundaryResponse200 = {
    data: BoundaryResponse;
    status: 200;
};

export type getBoundaryResponse400 = {
    data: void;
    status: 400;
};

export type getBoundaryResponse500 = {
    data: void;
    status: 500;
};

export type getBoundaryResponseSuccess = getBoundaryResponse200 & {
    headers: Headers;
};

export type getBoundaryResponseError = (getBoundaryResponse400 | getBoundaryResponse500) & {
    headers: Headers;
};

export type getBoundaryResponse = getBoundaryResponseSuccess | getBoundaryResponseError;

export const getGetBoundaryUrl = (id: string) => `/api/v1/boundaries/${id}`;

export const getBoundary = async (
    id: string,
    options?: RequestInit
): Promise<getBoundaryResponse> => {
    const res = await fetch(getGetBoundaryUrl(id), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getBoundaryResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getBoundaryResponse;
};

export type updateBoundaryResponse200 = {
    data: BoundaryResponse;
    status: 200;
};

export type updateBoundaryResponse400 = {
    data: void;
    status: 400;
};

export type updateBoundaryResponse500 = {
    data: void;
    status: 500;
};

export type updateBoundaryResponseSuccess = updateBoundaryResponse200 & {
    headers: Headers;
};

export type updateBoundaryResponseError = (
    | updateBoundaryResponse400
    | updateBoundaryResponse500
) & {
    headers: Headers;
};

export type updateBoundaryResponse = updateBoundaryResponseSuccess | updateBoundaryResponseError;

export const getUpdateBoundaryUrl = (id: string) => `/api/v1/boundaries/${id}`;

export const updateBoundary = async (
    id: string,
    updateBoundaryRequest: UpdateBoundaryRequest,
    options?: RequestInit
): Promise<updateBoundaryResponse> => {
    const res = await fetch(getUpdateBoundaryUrl(id), {
        ...options,
        body: JSON.stringify(updateBoundaryRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: updateBoundaryResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as updateBoundaryResponse;
};

export type assignSiteToBoundaryResponse204 = {
    data: void;
    status: 204;
};

export type assignSiteToBoundaryResponse400 = {
    data: void;
    status: 400;
};

export type assignSiteToBoundaryResponse500 = {
    data: void;
    status: 500;
};

export type assignSiteToBoundaryResponseSuccess = assignSiteToBoundaryResponse204 & {
    headers: Headers;
};

export type assignSiteToBoundaryResponseError = (
    | assignSiteToBoundaryResponse400
    | assignSiteToBoundaryResponse500
) & {
    headers: Headers;
};

export type assignSiteToBoundaryResponse =
    | assignSiteToBoundaryResponseSuccess
    | assignSiteToBoundaryResponseError;

export const getAssignSiteToBoundaryUrl = (id: string, siteId: string) =>
    `/api/v1/boundaries/${id}/sites/${siteId}`;

export const assignSiteToBoundary = async (
    id: string,
    siteId: string,
    options?: RequestInit
): Promise<assignSiteToBoundaryResponse> => {
    const res = await fetch(getAssignSiteToBoundaryUrl(id, siteId), {
        ...options,
        method: 'PUT'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: assignSiteToBoundaryResponse['data'] = body ? JSON.parse(body) : undefined;

    return { data, headers: res.headers, status: res.status } as assignSiteToBoundaryResponse;
};

export type unassignSiteFromBoundaryResponse204 = {
    data: void;
    status: 204;
};

export type unassignSiteFromBoundaryResponse400 = {
    data: void;
    status: 400;
};

export type unassignSiteFromBoundaryResponse500 = {
    data: void;
    status: 500;
};

export type unassignSiteFromBoundaryResponseSuccess = unassignSiteFromBoundaryResponse204 & {
    headers: Headers;
};

export type unassignSiteFromBoundaryResponseError = (
    | unassignSiteFromBoundaryResponse400
    | unassignSiteFromBoundaryResponse500
) & {
    headers: Headers;
};

export type unassignSiteFromBoundaryResponse =
    | unassignSiteFromBoundaryResponseSuccess
    | unassignSiteFromBoundaryResponseError;

export const getUnassignSiteFromBoundaryUrl = (id: string, siteId: string) =>
    `/api/v1/boundaries/${id}/sites/${siteId}`;

export const unassignSiteFromBoundary = async (
    id: string,
    siteId: string,
    options?: RequestInit
): Promise<unassignSiteFromBoundaryResponse> => {
    const res = await fetch(getUnassignSiteFromBoundaryUrl(id, siteId), {
        ...options,
        method: 'DELETE'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: unassignSiteFromBoundaryResponse['data'] = body ? JSON.parse(body) : undefined;

    return { data, headers: res.headers, status: res.status } as unassignSiteFromBoundaryResponse;
};

export type setPrimaryBoundaryResponse204 = {
    data: void;
    status: 204;
};

export type setPrimaryBoundaryResponse400 = {
    data: void;
    status: 400;
};

export type setPrimaryBoundaryResponse500 = {
    data: void;
    status: 500;
};

export type setPrimaryBoundaryResponseSuccess = setPrimaryBoundaryResponse204 & {
    headers: Headers;
};

export type setPrimaryBoundaryResponseError = (
    | setPrimaryBoundaryResponse400
    | setPrimaryBoundaryResponse500
) & {
    headers: Headers;
};

export type setPrimaryBoundaryResponse =
    | setPrimaryBoundaryResponseSuccess
    | setPrimaryBoundaryResponseError;

export const getSetPrimaryBoundaryUrl = (id: string) => `/api/v1/boundaries/${id}/primary`;

export const setPrimaryBoundary = async (
    id: string,
    options?: RequestInit
): Promise<setPrimaryBoundaryResponse> => {
    const res = await fetch(getSetPrimaryBoundaryUrl(id), {
        ...options,
        method: 'PUT'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: setPrimaryBoundaryResponse['data'] = body ? JSON.parse(body) : undefined;

    return { data, headers: res.headers, status: res.status } as setPrimaryBoundaryResponse;
};

export type getBoundariesResponse200 = {
    data: PagedResponseBoundaryResponse;
    status: 200;
};

export type getBoundariesResponse400 = {
    data: void;
    status: 400;
};

export type getBoundariesResponse500 = {
    data: void;
    status: 500;
};

export type getBoundariesResponseSuccess = getBoundariesResponse200 & {
    headers: Headers;
};

export type getBoundariesResponseError = (getBoundariesResponse400 | getBoundariesResponse500) & {
    headers: Headers;
};

export type getBoundariesResponse = getBoundariesResponseSuccess | getBoundariesResponseError;

export const getGetBoundariesUrl = (params?: GetBoundariesParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['sort'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach(v => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/v1/boundaries?${stringifiedParams}`
        : `/api/v1/boundaries`;
};

export const getBoundaries = async (
    params?: GetBoundariesParams,
    options?: RequestInit
): Promise<getBoundariesResponse> => {
    const res = await fetch(getGetBoundariesUrl(params), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getBoundariesResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getBoundariesResponse;
};

export type createBoundaryResponse201 = {
    data: BoundaryResponse;
    status: 201;
};

export type createBoundaryResponse400 = {
    data: void;
    status: 400;
};

export type createBoundaryResponse500 = {
    data: void;
    status: 500;
};

export type createBoundaryResponseSuccess = createBoundaryResponse201 & {
    headers: Headers;
};

export type createBoundaryResponseError = (
    | createBoundaryResponse400
    | createBoundaryResponse500
) & {
    headers: Headers;
};

export type createBoundaryResponse = createBoundaryResponseSuccess | createBoundaryResponseError;

export const getCreateBoundaryUrl = () => `/api/v1/boundaries`;

export const createBoundary = async (
    createBoundaryRequest: CreateBoundaryRequest,
    options?: RequestInit
): Promise<createBoundaryResponse> => {
    const res = await fetch(getCreateBoundaryUrl(), {
        ...options,
        body: JSON.stringify(createBoundaryRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'POST'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: createBoundaryResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as createBoundaryResponse;
};
